import React from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';

import { QUERY_UNION_BOOKING_DETAIL, MUTATION_CANCEL_BOOKING } from '../queries';

import Detail from './detail';

export default function MessagePropertyDetail() {
  const { t } = useTranslation(['landlord']);
  const { pathname } = useLocation();
  const referenceId = pathname.split('/')[2];

  const { data, loading, refetch } = useQuery(QUERY_UNION_BOOKING_DETAIL, {
    fetchPolicy: 'no-cache',
    variables: {
      referenceId,
    },
  });

  const [cancelBooking] = useMutation(MUTATION_CANCEL_BOOKING, {
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        id: data?.getUnionBooking?.order?.id,
      },
    },
    onCompleted: res => {
      if (res.cancelOrderOnCMS.order) {
        refetch();
      }
    },
  });

  if (loading) {
    return (
      <div
        style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Spin />
      </div>
    );
  }
  return <Detail order={data?.getUnionBooking?.order ?? {}} t={t} cancelBooking={cancelBooking} />;
}
